import { Navigate, useLocation } from "react-router";
import { useAuth } from "../app/context";
import { returnUrlOf } from "../app/guards";
import { loginPath } from "../config";
import { MapPage } from "./MapPage";
import { PublicMapPage, publicMapIdOf } from "./PublicMapPage";

export function MapEntry() {
  const location = useLocation();
  const token = useAuth(a => a.token);
  const publicMapId = publicMapIdOf(location.search);

  if (publicMapId !== null) return <PublicMapPage key={publicMapId} id={publicMapId} />;
  if (token === null) return <Navigate to={loginPath(returnUrlOf(location.pathname, location.search))} replace />;

  return <MapPage />;
}
